<template>
	<div class="position-relative">
	<div  
		class="p-1"   
		v-if="!isLoading && activity.registration && !activity.alreadySignup && !activity.cancelled">
		<md-button
		  class="md-button md-sm d-inline md-success"
			@click="signUpClass()"
			 :disabled="!(hayLugar() && tieneCupos())"
		  v-if="!isPastDay() && activity.registration && !isGym() && !isTeacher() && !myclasses">
		  <md-icon>app_registration</md-icon>
		  <span v-if="hayLugar() && tieneCupos()">{{ $t('signUpForThisClass') }}</span>
		  <span v-if="!hayLugar() && tieneCupos()">0 {{$t('remainingQuota')}}</span>
  		<span v-if="!tieneCupos()">{{$t('noQuotaLeft')}}</span>
		</md-button>
	</div>

	  <div v-if="edit && !phone"  class="position-absolute top-0 right-0">
        <button class="border-round bg-primary mr-2" @click="editActivity()">
          <md-icon class="text-white cursor-pointer">edit</md-icon>
        </button>
        <button class="border-round bg-danger" @click="deleteAct()">
          <md-icon class="text-white cursor-pointer">close</md-icon>
        </button>
      </div>


	<div class="w-100">
	
	<strong>{{ activity.name }}</strong>
	<strong v-if="activity.cancelled" class="text-danger ml-2">[EVENTO CANCELADO]</strong>
		
	    <PlanningSlide
	    	v-if="planning" 
	    	            @goTo="goTo($event)" 
        :plannings="[planning]"
      />


      
	<div class="text-secondary ">
 		<strong v-if="!activity.startDate">Todos los {{daysOfWeek[activity.day]}}</strong>
	  <strong>
	  <strong v-if="activity.endTime"> de</strong><strong v-else> a las</strong>  {{ activity.startTime }} hs
	  </strong>
	   <strong v-if="activity.endTime">
	  a {{ activity.endTime }} hs
	  </strong>
	</div>



	</div>
	<div  class="px-1 w-100">
	<small v-if="activity.registration" class="p-2">
	  <small v-if="activity.cupos > -1" class=" text-success"><md-icon class=" text-success">groups</md-icon> 
	  Quedan {{ activity.cupos - activity.users.length }} lugares</small>
	  <small v-if="activity.cupos == null"><md-icon>groups</md-icon> {{ $t('remainingQuota') }}: 0</small>
	  <small v-if="activity.cupos == -1">{{ $t('unlimitedQuota') }}  <md-icon>all_inclusive</md-icon></small>
	  <br>
	</small>
	<span v-if="activity.registration">
	  <small v-if="!activity.consumequota" class=" text-success">
	   <md-icon class=" text-success">meeting_room</md-icon> {{ $t('anyClientCanSignUp') }}</small>
	  <small v-else class=" text-success">
	   <md-icon class=" text-success">door_front</md-icon>Clase con inscripción por cupos</small>
  </span>
  <div  v-if="isGym()" class="w-100">
  <span class="badge badge-danger float-left" v-if="!activity.startDate">Actividad recurrente</span><br>
  <small class="text-secondary">
    <strong>Created at: {{ activity.createdAt.split('T')[0] }} {{ activity.createdAt.split('T')[1].split('.')[0] }}</strong>
  </small>
  </div>

	<small class="badge badge-success && !myclasses" v-if="activity.alreadySignup">{{ $t('allready') }}</small>
	<small class="badge badge-danger" v-if="!hayLugar() && !isPastDay() && activity.cupos > -1">{{ $t('noSlotsAvailable') }}</small>
	<div class="w-100">
		<md-button
			v-if="getCantUserEnrolled() && (isGym() || isTeacher())"
		  class="md-button md-sm d-inline md-success"
		  @click="openModal()">
		  <md-icon v-if="classicModal">keyboard_arrow_down</md-icon>
		  <md-icon v-else>keyboard_arrow_up</md-icon>
		  {{ $t('enrolledPeople') }}  <span v-if="activity.users && Array.isArray(activity.users)">({{activity.users.length}})</span>
		</md-button>
		<md-button
			v-if="!getCantUserEnrolled() && (isGym() || isTeacher())"
		  class="md-button md-sm d-inline md-success"
		  disabled>
		  	No hay inscriptos
		</md-button>

    <div class="w-100 float-left card p-4" v-if="getCantUserEnrolled() && classicModal" > 
    		<div v-for="item in getUserEnrolled()" class="w-100">
						
						  <div class="mt-2">
						  	<strong class="pl-2 text-secondary"> {{ item.name }}</strong><small class="pl-2 text-secondary"> {{ item.email }}</small>
						  	   <md-button class="md-btn md-danger md-sm" 
				            v-if="(!isPastDay() && isClientGym()) || (isGym() || isTeacher())" 
				            @click="deleteClass(activity._id,item._id,activity.startDate)">{{$t('unsubscribe')}}</md-button>
						  </div>
    		</div>
    </div>
    </div>
	</div>
	</div>
</template>
<script>

import { 
  getPlanningAction
} from '@/pages/Training/actions';
import { getAllUsersAction } from "@/pages/Users/actions";
import { format, addMonths, subMonths, getDay, isToday, isBefore } from 'date-fns';
import { deleteClassAction, getMyClassesAction } from "@/pages/Stablishments/actions";
import PlanningSlide from '@/pages/Training/PlanningSlide.vue';
import { getProfileStablishmentsAction } from "@/pages/Stablishments/actions";
import Swal from 'sweetalert2';

import permissionsMixin from '@/mixins/permissionsMixin';

export default {
  mixins: [permissionsMixin],
  name:"activity",

	created() {
			if(this.activity.planningId){
				this.getPlanning();
			}
			if(this.activity.users.length && (this.isGym() || this.isTeacher())){
				 this.getAll();
			}
      this.getStablishments();
	},
	data() {
		return {
			planning:false,
			classicModal: false,
			openUsers:[],
			remainingCupos:false,
      defaultLogo: "/img/placeholder.jpg",
			users:[],
      allStablishments:[],
      stablishment:null,
      isLoading:true,
      daysOfWeek: ['Domingo','Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']
		}
	},
  components: {
    PlanningSlide,
  },
  computed: {
    userEnrolled() {
      return this.users.filter(user => this.activity.users.includes(user._id));
    },
  },
  props: {
    myclasses: {
      type: Boolean,
      default: () => false,
    },
    activity: {
      type: Object,
      default: () => {},
    },
    phone: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    edit: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    day: {
      type: Date,
      default: () => {
        return true;
      }
    },

  },
  methods:{
    getCantUserEnrolled(){
      return this.userEnrolled.length
    },
    getUserEnrolled(){
      return this.userEnrolled;
    },
    async getStablishments(){
      this.isLoading = true;

      try {
        const stablishmentsResponse = await getProfileStablishmentsAction();
        this.allStablishments = stablishmentsResponse.stablishments;
        if(this.allStablishments){
          this.stablishment = this.allStablishments[0];
        }
      } catch (error) {
        console.error('Error loading stablishments:', error);
      } finally {
        this.isLoading = false;
      }
    },
    goTo(item) {
      this.$router.push({
        name: 'PlanningView',
        params: { id: item._id, objeto: { id: item._id, planning: item } },
      });
      this.id = item._id;
      this.start();
    },
    async getPlanning(){
      const response = await getPlanningAction(this.activity.planningId);
      if (response.ok) {
        this.planning = response.planning;
      }
    },
    async getAll() {
      try {
        const response = await getAllUsersAction();
        this.users = response.users;
      } catch (error) {
        this.errorMessage = error.message;
      }
    },
  	openModal(){
      this.classicModal = !this.classicModal;
  	},
    classicModalHide() {
      this.classicModal = false;
    },
  	hayLugar(){
  		return (this.activity.cupos < 0 || (this.activity.cupos - this.activity.users.length) > 0);
  	},
  	tieneCupos(){
  	  const profile = JSON.parse(localStorage.getItem('profile'));
  	  this.remainingCupos = profile.remainingCupos
			return (this.remainingCupos > 0);
  	},
    isPastDay() {
        console.log('Activity:', this.activity);
        // Si no tiene startDate, es una clase recurrente
        if(!this.activity.startDate){
            console.log('=== DEBUG isPastDay (Clase recurrente) ===');
            // Usar el día que viene como prop
            const selectedDay = new Date(this.day);
            
            // Obtener la fecha actual en Argentina (UTC-3)
            const now = new Date();
            const argentinaTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/Argentina/Buenos_Aires' }));
            console.log('Hora en Argentina:', argentinaTime.toLocaleString());
            
            // Crear fecha con la hora de la clase (ya está en hora de Argentina)
            const [hours, minutes] = this.activity.startTime.split(':').map(Number);
            const classTime = new Date(selectedDay);
            classTime.setHours(hours, minutes, 0, 0);
            
            console.log('Hora de la clase:', this.activity.startTime);
            console.log('Fecha seleccionada:', selectedDay.toLocaleString());
            console.log('Fecha de la clase:', classTime.toLocaleString());
            
            // Si es hoy, verificar la hora
            if (isToday(selectedDay)) {
                console.log('Es hoy, comparando horas');
                console.log('Hora actual (AR):', argentinaTime.toLocaleString());
                console.log('Hora de la clase:', classTime.toLocaleString());
                console.log('¿Es pasado?:', argentinaTime > classTime);
                return argentinaTime > classTime;
            }

            // Si el día seleccionado es anterior a hoy, es pasado
            if (isBefore(selectedDay, argentinaTime)) {
                console.log('Es un día anterior');
                return true;
            }

            console.log('Es un día futuro');
            return false;
        }

        // Para clases con fecha específica
        console.log('=== DEBUG isPastDay (Clase con fecha específica) ===');
        let day = this.activity.startDate;
        
        // Obtener la fecha actual en Argentina (UTC-3)
        const now = new Date();
        const argentinaTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/Argentina/Buenos_Aires' }));
        console.log('Hora en Argentina:', argentinaTime.toLocaleString());
        
        // Extraer la hora directamente del string ISO
        const [datePart, timePart] = day.split('T');
        const [year, month, dayOfMonth] = datePart.split('-');
        const [hours, minutes] = timePart.split(':');
        const activityTime = new Date(year, month - 1, dayOfMonth, hours, minutes);
        
        console.log('Fecha de la actividad:', activityTime.toLocaleString());
        console.log('inscriptionBefore:', this.stablishment?.businessName?.inscriptionBefore);
        console.log('unscriptionBefore:', this.stablishment?.businessName?.unnscriptionBefore);
        
        let limitTime = new Date(activityTime);
        
        if(!this.myclasses){
              // If inscriptionBefore exists and is a number, use it as hours
          if (this.stablishment?.businessName?.inscriptionBefore && !isNaN(this.stablishment.businessName.inscriptionBefore)) {
              const hoursBefore = parseInt(this.stablishment.businessName.inscriptionBefore);
              limitTime = new Date(activityTime);
              limitTime.setHours(activityTime.getHours() - hoursBefore);
              console.log('Límite de inscripción:', limitTime.toLocaleString());
          }
        }
     

        console.log('¿Es pasado?:', argentinaTime > limitTime);
        return argentinaTime > limitTime;
    },
    isTodayDay(day) {
      const localDate = new Date(day);
      localDate.setHours(0, 0, 0, 0);
      return isToday(localDate);
    },
    async deleteClass(id, userId, day) {

      if(this.isGym()){
        await deleteClassAction(id, userId);

      Swal.fire({
            title: 'Usuario retirado con exito',
            icon: 'success',
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
          });
        return;
      }
      // If it's today's class, check the unsubscription time limit
      if (this.isTodayDay(day)) {
        const now = new Date();
        const activityTime = new Date(day);
        
        // Check if there's an unsubscription time limit
        if (this.stablishment?.businessName?.unnscriptionBefore && !isNaN(this.stablishment.businessName.unnscriptionBefore)) {
          const hoursBefore = parseInt(this.stablishment.businessName.unnscriptionBefore);
          const limitTime = new Date(activityTime);
          limitTime.setHours(activityTime.getHours() - hoursBefore);
          
          // If current time is past the limit time, prevent unsubscription
          if (now > limitTime) {
            Swal.fire({
              title: 'No puedes cancelar ahora',
              text: `Lo sentimos pero no puedes cancelar la clase cuando faltan menos de ${hoursBefore} horas para que comience. Contactate con nosotros.`,
              icon: 'warning',
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            });
            return;
          }
        }
        
        // If not gym, show the original warning
        if (!this.isGym()) {
          Swal.fire({
            title: 'No puedes cancelar ahora',
            text: 'Lo sentimos pero falta muy poco para que comience esta clase. Contactate con nosotros.',
            icon: 'warning',
            showCancelButton: true,
            showConfirmButton: false,
            confirmButtonColor: '#3085d6',
          });
          return;
        }
      }

      await deleteClassAction(id, userId);

      Swal.fire({
            title: 'Usuario retirado con exito',
            icon: 'success',
            showCancelButton: true,
            showConfirmButton: false,
            confirmButtonColor: '#3085d6',
          });

    },
  	signUpClass(){
  		this.$emit('signUpClass',{id: this.activity._id,day: this.day});
  	},
  	deleteAct(){
  		this.$emit('deleteAct',this.activity._id);
  	},
  	editActivity(){
  		this.$emit('editActivity', {...this.activity, selectedDay: this.day});
  		 const targetElement = document.getElementById('collapsetotal23');
	    if (targetElement) {
	        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
	    }
  	}
  }
 }

 </script>

 <style>

 .right-0{
   right:0;
 }
.border-round{
border-radius: 50%;
    border: 0;
    width: 31px !important;
    height: 31px !important;
    padding: 0px !important;
}
.border-round i{
font-size: 20px !important;}

 </style>

